import { useMemo } from 'react';
import { between } from '@hotjar/insights-common/lib/between';

interface SsoErrorCodeProps {
  code: string | null;
  apiErrorMessageKey: string | null;
}
const errorCodeMin = 1;
const errorCodeMax = 11;

// Validate the error-code param. For now, we just check if its in
// the range 1..11
const validateParam = (param: string | null): boolean => {
  const isValid = between(param, errorCodeMin, errorCodeMax);

  return isValid;
};

const errorMessageToLocaleKey = (errorMessage: string): string => {
  switch (errorMessage) {
    case 'The invitation is not valid':
      return 'invitation-not-valid';
    case 'The invitation was not found':
      return 'invitation-not-found';
    case 'Login ID does not exist':
      return 'loginid-does-not-exist';
    case 'No user found for this email-Login ID combination':
      return 'no-user';
    /* GENERIC */
    /* DEFAULT – Return a generic error message. */
    case 'Oops. Something went wrong.':
    default:
      return 'generic';
  }
};

/**
 * Simple hook that receives the api error message and returns the
 * locale string (which is used to render a user friendly locale message).
 * Also return the error_code from the seacrch params appended to the url
 * when the Sso flow fails.
 */
export function useSsoError(errorMessage: string | null): SsoErrorCodeProps {
  return useMemo(() => {
    const {
      location: { search },
    } = window;

    const params = new URLSearchParams(search);
    const codeParam = params.get('error_code');
    const errorCode = validateParam(codeParam) ? codeParam : null;

    return {
      code: errorCode,
      apiErrorMessageKey: errorMessage ? errorMessageToLocaleKey(errorMessage) : null,
    };
  }, [errorMessage]);
}
